import { GetterTree } from 'vuex';
import { AddFundsState } from './types';
import { RootState } from '@/store/types';
import { ADDFUNDS_IS_OPEN} from '@/modules/add-funds/store/constants';

const getters: GetterTree<AddFundsState, RootState> = {
    [ADDFUNDS_IS_OPEN](state: AddFundsState): boolean {
        return state.open;
    },
};

export default getters;
